// src/components/layout/MinimalFooter.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const MinimalFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className="flex-shrink-0 border-t border-gray-100 bg-white">
      <div className="max-w-6xl mx-auto px-6 h-10 flex items-center justify-between">
        <span className="text-xs text-gray-400">
          © {new Date().getFullYear()} Entelligentsia Solutions LLP · Pune, India
        </span>
        <div className="flex items-center gap-5">
          <button
            onClick={() => navigate('/blog')}
            className="text-xs text-gray-400 hover:text-gray-700 transition-colors"
          >
            Blog
          </button>
          <a
            href="https://github.com/Entelligentsia"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-gray-400 hover:text-gray-700 transition-colors"
          >
            GitHub
          </a>
          <a
            href="mailto:contactus@entelligentsia.in"
            className="text-xs text-gray-400 hover:text-gray-700 transition-colors"
          >
            contactus@entelligentsia.in
          </a>
        </div>
      </div>
    </footer>
  );
};

export default MinimalFooter;
